import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Funcionalidade } from "src/app/enums/funcionalidade.enum";
import { Rules } from "src/app/interfaces/rules.interface";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { semNavegacaoEmFalha } from "src/app/security/http-context.tokens";

@Injectable({
  providedIn: "root",
})
export class RulesService {
  private funcionalidades = {
    dashboard: Funcionalidade.AccessoBackoffice,
    "usuario-consulta": Funcionalidade.Usuario,
    "usuario-cadastro": Funcionalidade.Usuario,
    "perfil-consulta": Funcionalidade.Perfil,
    "perfil-cadastro": Funcionalidade.Perfil,
    "comunidade-associados-consulta": Funcionalidade.Forum_Comunidade_Associado,
    "comunidade-associados-cadastrar": Funcionalidade.Forum_Comunidade_Associado,
    "comunidade-associados-visualizar": Funcionalidade.Forum_Comunidade_Associado,
    "comissoes-tecnicas-consulta": Funcionalidade.Forum_Comissoes_Tecnicas,
    "comissoes-tecnicas-visualizar": Funcionalidade.Forum_Comissoes_Tecnicas,
    "comissoes-tecnicas-cadastrar": Funcionalidade.Forum_Comissoes_Tecnicas,
    "grupos-trabalho-consulta": Funcionalidade.Forum_Grupo_Trabalho,
    "grupos-trabalho-cadastrar": Funcionalidade.Forum_Grupo_Trabalho,
    "grupos-trabalho-visualizar": Funcionalidade.Forum_Grupo_Trabalho,
    "moderacao-aprovar-reprovar": Funcionalidade.Forum_Comunidade_Associado,
    "moderacao": Funcionalidade.Forum_Comunidade_Associado,
    "minhas-postagens": Funcionalidade.Forum_Comunidade_Associado,
    "ata-consulta": Funcionalidade.Atas,
    "ata-cadastro": Funcionalidade.Atas,
    "evento-consulta": Funcionalidade.Eventos,
    "evento-cadastro": Funcionalidade.Eventos,
    "agenda-eventos": Funcionalidade.AccessoBackoffice,
    "noticias": Funcionalidade.News,
    "noticia": Funcionalidade.News,
    "chamados": Funcionalidade.ChamadoMeusChamados,
    "meus-chamados": Funcionalidade.ChamadoMeusChamados,
    "especialista": Funcionalidade.ChamadoModeracao,
  };

  access: Rules;
  lastUrl = "";

  constructor(private http: HttpClient) {}

  check(id: Funcionalidade): Observable<Rules> {
    return this.http.get<Rules>(
      `${environment.apiUrlControleDeAcesso}/seguranca/permissions/backoffice/${id}`
    );
  }

  /**
   * Mesma consulta de `check`, para uso fora do guard (ex.: blocos da Home).
   * Não grava em `access` (que pertence à rota atual) e não navega para página
   * de erro em falha.
   */
  checkSilencioso(id: Funcionalidade): Observable<Rules> {
    return this.http.get<Rules>(
      `${environment.apiUrlControleDeAcesso}/seguranca/permissions/backoffice/${id}`,
      semNavegacaoEmFalha()
    );
  }

  getFuncionalidade(url: string): number {
    if (!url) return 0;

    // remove barra inicial, querystring e fragmento
    const clean = url.replace(/^\/+/, "").split("?")[0].split("#")[0];

    if (clean.startsWith("meus-chamados")) return Funcionalidade.ChamadoMeusChamados;
    if (clean.startsWith("especialista")) return Funcionalidade.ChamadoModeracao;

    if (clean.startsWith("chamados/moderacao")) return Funcionalidade.ChamadoModeracao;
    if (clean.startsWith("chamados")) return Funcionalidade.ChamadoMeusChamados;

    // pega só o primeiro segmento do path
    const firstSeg = clean.split("/")[0];

    return this.funcionalidades[firstSeg] ?? 0;
  }
}
